(function() {
    var m = angular.module('utils');

    m.directive('courses', [function() {
        return {
            require: 'ngModel',
            priority: 1,
            link: function(scope, elm, attrs, ngModel) {
                if (attrs.courses) {
                    scope.$watch(attrs.courses, function() {
                        var list = scope.$eval(attrs.courses);
                        $(elm).html('');
                        var catI;
                        var corI;
                        var group;
                        for (catI in list) {
                            group = $('<optgroup>').attr('label', catI);
                            for (corI in list[catI]) {
                                group.append($('<option>')
                                    .val(list[catI][corI].id)
                                    .html(list[catI][corI].title));
                            }
                            $(elm).append(group);
                        }
                        $(elm).val(ngModel.$viewValue);
                        $(elm).trigger('refresh'); // for jQuery Form Styler - update options list
                    }, true);
                }
            }
        };
    }]);
})();
